import { render, staticRenderFns } from "./ImportThaibev.vue?vue&type=template&id=e6356da6&scoped=true&"
import script from "./ImportThaibev.vue?vue&type=script&lang=js&"
export * from "./ImportThaibev.vue?vue&type=script&lang=js&"
import style0 from "./ImportThaibev.vue?vue&type=style&index=0&id=e6356da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6356da6",
  null
  
)

export default component.exports